// Pure helpers for the Forecasting Overview (ui/src/admin/ForecastOverview.jsx). A week carries its need
// and gap twice: Phone on the planning standard (hours x 1.23) and Phone on the service level (the
// agents Erlang A says hold the answer and abandon goals). The page shows one at a time.
export const BASIS_SERVICE = 'service'
export const BASIS_PLANNING = 'planning'

// The need and gap of a row on a basis. Falls back to the planning basis for a row with no service line.
export function pickBasis(row, basis) {
  if (basis === BASIS_SERVICE && row.service) return { need: row.service.need, gap: row.service.gap }
  return { need: row.need, gap: row.gap }
}

// True when at least one week has a service-level Phone line, so the toggle has something to show.
export function hasServiceLevel(report) {
  return [...(report.weeks ?? []), ...(report.coming ?? [])].some((r) => r.service?.need?.phone != null)
}

// The basis the page opens on: the service level when it exists, else the planning standard.
export function defaultBasis(report) {
  return hasServiceLevel(report) ? BASIS_SERVICE : BASIS_PLANNING
}
